
const situationModule = {
    namespaced: true,
    state: {
        time: '',
        areaDistData: []
    },
    actions: {
    },
    mutations: {
        setAreaDistData(state, data) {
            state.areaDistData = data;
        },
        setTime(state, time) {
            state.time = time;
        }
    },
    getters: {
        
    }
};

export default situationModule;

